// global.SET_API_URL = 'https://servernms.whdevs.com/'

global.SET_API_URL = 'https://servermaltex.whdevs.com/'

// global.SET_API_URL = 'https://server-hrms-roplant.whdevs.com/'

// global.SET_API_URL = 'https://server.hrms.lb.whdevs.com/'

// global.SET_API_URL = 'http://localhost:5000/'

// global.SET_API_URL = 'http://localhost:5000/'

global.COMPANY_NAME = 'WORLD HOME DEVELOPMENT'
global.targetDate = new Date()
global.msgError = ''

// global.monthsData = [
//     { monthID: 1, monthName: "January" },
//     { monthID: 2, monthName: "February" },
//     { monthID: 3, monthName: "March" },
//     { monthID: 4, monthName: "April" },
//     { monthID: 5, monthName: "May" },
//     { monthID: 6, monthName: "June" },
//     { monthID: 7, monthName: "July" },
//     { monthID: 8, monthName: "August" },
//     { monthID: 9, monthName: "September" },
//     { monthID: 10, monthName: "October" },
//     { monthID: 11, monthName: "November" },
//     { monthID: 12, monthName: "December" }
// ];
